// extracted by mini-css-extract-plugin
export var item = "Breadcrumbs-module--item--a917d";
export var root = "Breadcrumbs-module--root--dc2e5";